import { gql } from '@apollo/client';

export const CREATE_CLASSIFY_AUDIT_LOGS_FOR_FRY7Q = gql`
mutation createClassifyAuditLogForFRY7Q($input: ClassifyFRY7QInput) {
	createClassifyAuditLogForFRY7Q(input: $input)
}`;

export const CREATE_FRY7Q_USER_COMMENT = gql`
mutation createFRY7QUserComment($input: CreateFRY7QUserCommentInput) {
	createFRY7QUserComment(input: $input)
}`;

export const DELETE_FRY7Q_USER_COMMENT = gql`
mutation deleteFRY7QUserComment($input: DeleteFRY7QUserCommentInput) {
	deleteFRY7QUserComment(input: $input)
}`;

export const UPDATE_FRY7Q_USER_COMMENT = gql`
mutation updateFRY7QUserComment($input: UpdateFRY7QUserCommentInput){
	updateFRY7QUserComment(input: $input)
}`;

export const VALIDATE_REMEDIATION_FOR_FRY7Q = gql`
mutation validateRemediationForFRY7Q ($input: ValidationForFRY7QInput) {
	validateRemediationForFRY7Q (input: $input) {
		mdrmNumber
		ruleDescription
		previousRunStatus
		newRunStatus
		ruleId
		schedule
		targetItem
	}
}`;

export const RUN_REMEDIATION_FOR_FRY7Q = gql`
mutation runRemediationForFRY7Q($input:RemediationForFRY7QInput) {
	runRemediationForFRY7Q(input: $input)
}`;
